import env from '../env';

export const sendPartnerFeatures = (autoActivation: boolean) => {
  try {
    chrome.runtime.sendMessage(env.kindred_extension_id, {
      type: 'partnerFeatures',
      autoActivation,
    });
  } catch (error) {
    //
  }
};
